<template>
  <div class="grid-layer">
    <table
      ref="table"
      :class="{transparent:!visible}"
      :style="{width:tableWidth+'px', height:tableHeight+'px', left:'0px', top:'0px'}"
    >
      <tr v-for="(row, indexY) in cells" v-bind:key="row[0].key">
        <td
          v-bind:class="{cell: cell.key != currentZone, 'cell-active': cell.key == currentZone}"
          v-for="(cell, indexX) in row"
          v-bind:key="cell.key"
          :style="{width:tileWidth+'px', height:tileHeight+'px'}"
          @click="onClickCell(cell)"
        >
          <area-cell :x="cell.x" :y="cell.y" v-if="isArea(cell)" />
          <div
            v-if="mapType == 0"
            v-bind:style="{'background-image': `url('/img/world/bg_world_m_${parseInt(indexY) * 8 + parseInt(indexX) + 1}.png')`, width: '100%', height: '100%', 'padding-top': '12px', 'background-size': '100% 100%'}"
          >
            <img
            v-if="!IsAvailableZone(cell)"
              v-bind:src="`img/bg_world_none_${((cell.x + cell.y) % 2) + 1}.png`"
              style="position: absolute; left:0px; top:0px;"
              v-bind:width="`${tileWidth}px`"
              v-bind:height="`${tileHeight}px`"
            />
            <img
              src="/img/select_world.png"
              v-if="cell.key == currentZone"
              style="position: absolute; left:0px; top:0px;"
              v-bind:width="`${tileWidth}px`"
              v-bind:height="`${tileHeight}px`"
            />            
          </div>
          <div
            v-if="mapType == 1"
            v-bind:style="{'background-image': cellImg(cell), width: '100%', height: '100%', 'background-size': '100% 100%', position: 'relative'}"
          >
            <img
              src="/img/select_zone.png"
              v-if="parseInt(cell.key) === parseInt(selectedLandId)"
              width="100%"
              style="position: absolute; left: 0px; top: 0px;"
            />
            <img
              src="/img/1st_sale/icon_select.png"
              v-if="IsSelected(cell.key)"
              width="100%"
              style="position: absolute; left: 0px; top: 0px;"
            />
          </div>
          <!-- <div v-if="mapType == 1 && visibleDevRank == 'on'" v-bind:style="{width: '100%', height: '100%', 'background-color': devColor[cell.rank]}"></div>           -->
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import config from "../../config.js";

import AreaCell from "./AreaCell.vue";
export default {
  name: "GridLayer",
  components: { AreaCell },
  props: {
    viewport: {
      type: Object
    },
    visible: {
      type: Boolean
    },
    visibleDevRank: {
      type: String
    },
    columnCount: { type: Number, default: 32 },
    rowCount: { type: Number, default: 32 },
    tileWidth: { type: Number, default: 25 },
    tileHeight: { type: Number, default: 25 },
    mapType: { type: Number, default: 0 },
    onSale: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    cells: [],
    lands: [],
    devColor: [
      "#d9e99f",
      "#9ca96c",
      "#6ba762",
      "#409050",
      "#207f43",
      "#0d672e",
      "#035229",
      "#014321",
      "#002713",
      "#011200"
    ],
    saleColor: ["#000000", "#999999", "#ffffff"],
    selectedLandId: 0,
    zones: []
  }),
  computed: {
    allLands() {
      return this.lands;
    },
    allCells() {
      return this.cells;
    },
    refreshZone() {
      return this.$store.state.map.refreshZone;
    },
    currentZone() {
      return this.$store.state.map.currentZone;
    },
    currentLandId() {
      if (this.$store.state.area.selectedLand == null) {
        return 0;
      }
      console.log("currentLandId: ", this.$store.state.area.selectedLand[0]);
      return this.$store.state.area.selectedLand[0];
    },
    tableWidth() {
      return this.tileWidth * this.columnCount;
    },
    tableHeight() {
      return this.tileHeight * this.rowCount;
    }
  },
  mounted() {
    this.$nextTick(async () => {
      this.setPositionByViewport();
      if (this.mapType == 1) {
        let lands = await this.getZoneLands(this.currentZone);
        this.lands = lands;
        this.createCells();
        console.log("selectedId - ", this.selectedId);
        if (this.selectedId == 0) {
          this.selectedLandId = lands[0][0];
          this.$store.commit("clickMap", {
            key: lands[0][0],
            land: lands[0]
          });
        } else {
          this.selectedLandId = this.selectedId;
          for (let i = 0; i < lands.length; ++i) {
            if (lands[i][0] == this.selectedLandId) {
              this.$store.commit("clickMap", {
                key: lands[i][0],
                land: lands[i]
              });
              break;
            }
          }
        }
        this.updateCellXY(lands);        
      }
      else {
        let lands = await this.getZoneLands(this.currentZone);
        this.lands = lands;
        this.createCells();
        this.updateCellXY(lands);
        this.zones = await this.getZoneStatus();
      }
      setTimeout(() => {
        $(this.$el).css({ opacity: 1 });
      }, 10);
    });
  },
  watch: {
    async refreshZone(val, oldVal) {
      if (val == false) {
        return;
      }
      this.$store.commit("refreshZone", { refresh: false });
      if (this.mapType == 0) {
        return;
      } else {
        let lands = await this.getZoneLands(this.currentZone);
        this.lands = lands;
        this.selectedLandId = lands[0][0];
        this.updateCellXY(lands);
        //this.updateCellXY(val);
      }
    },
    async currentZone(val, oldVal) {
      if (this.mapType == 0) {
        return;
      } else {
        let lands = await this.getZoneLands(val);
        this.lands = lands;
        if (this.selectedId == 0) {
          if (!this.$store.state.account.multiSelect) {
            this.selectedLandId = lands[0][0];
            this.$store.commit("clickMap", {
              key: lands[0][0],
              land: lands[0]
            });
          }          
        } else {
          this.selectedLandId = this.selectedId;
          for (let i = 0; i < lands.length; ++i) {
            if (lands[i][0] == this.selectedLandId) {
              this.$store.commit("clickMap", {
                key: lands[i][0],
                land: lands[i]
              });
              break;
            }
          }
        }
        this.updateCellXY(lands);
        //this.updateCellXY(val);
      }
    }
  },
  methods: {
    IsAvailableZone: function(cell) {
      if (!this.onSale) {
        return true;
      }
      let zoneId = cell.key;
      for (let i = 0; i < this.zones.length; ++i) {
        if (this.zones[i].zoneId == zoneId) {
          if (this.zones[i].remain <= 0) {
            return false;
          }
          return true;
        }
      }
      return false;
    },
    IsSelected: function(landId) {
      for (let i = 0; i < this.$store.state.map.selectedLands.length; ++i) {
        if (this.$store.state.map.selectedLands[i] == landId) {
          return true;
        }
      }
      return false;
    },
    cellImg: function(cell) {
      if (cell.owner != false) {
        if (cell.address != null && this.$store.state.account.wallet != null && this.$store.state.account.wallet.address != null && cell.address.toLowerCase() == this.$store.state.account.wallet.address.toLowerCase()) {
          return `url('/img/bg_user.png')`;
        }
        else {
          return `url('/img/1st_sale/bg_buy.png')`;
        }        
      } else {
        if ((cell.sale != 2 || cell.reserved != null) && this.onSale == true) {
          if (cell.x % 2 == cell.y % 2) {
            return `url('/img/bg_none_1.png')`;
          } else {
            return `url('/img/bg_none_2.png')`;
          }
        } else {
          return `url('/img/bg_land_${cell.rank}.png')`;
        }
      }
    },
    getHexColor: function(number) {
      return "#" + (number >>> 0).toString(16).slice(-6);
    },
    getZoneStatus: function() {
      return new Promise((resolve, reject) => {
        axios
          .post(`${config.api.nft_url}/presale/allzone`, {})
          .then(ret => {
            if (ret.data.result == true) {
              resolve(ret.data.zones);
            } else {
              reject();
            }
          });
      });
    },
    getZoneLands: function(zoneId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${config.api.game_url}/land/zone/lands?zoneId=${zoneId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              resolve(ret.data.lands);
            } else {
              reject();
            }
          });
      });
    },
    setPositionByViewport() {
      $(this.$el).css({
        left: this.viewport.left,
        top: this.viewport.top
      });
    },
    updateCellXY(lands) {
      let currentZone = this.currentZone;
      const cells = this.cells;
      let idx = 0;
      let currentZoneIdx = 0;
      let startLandId = 100000;
      for (let i = 0; i < this.$store.state.map.zoneMap.length; ++i) {
        if (this.$store.state.map.zoneMap[i] == currentZone) {
          currentZoneIdx = i;
          break;
        }
      }
      let zoneX = currentZoneIdx % 8;
      let zoneY = 7 - Math.floor(currentZoneIdx / 8);
      startLandId = (zoneY * 256 + zoneX) * 32 + 100000;

      if (this.cells == null) {
        return;
      }

      for (let i = 0; i < this.rowCount; i++) {
        for (let j = 0; j < this.columnCount; j++) {
          if (this.mapType == 0) {
            let key = this.$store.state.map.zoneMap[idx];
            cells[i][j] = { x: j, y: i, i, j, key, display: key };
          } else {
            let key = startLandId + j + (31 - i) * 256;

            if (lands.length > idx) {
              this.$set(cells[i], j, {
                x: j,
                y: i,
                i,
                j,
                key,
                rank: lands[idx][1],
                display: lands[idx][1],
                sale: lands[idx][3],
                owner: lands[idx][2],
                color: this.getHexColor(lands[idx][4]),
                land: lands[idx],
                reserved: lands[idx][5],
                address: lands[idx][6]
              });
            } else {
              this.$set(cells[i], j, {
                x: j,
                y: i,
                i,
                j,
                key,
                rank: 1,
                display: 0,
                sale: 0,
                owner: false,
                color: "#000000",
                address: null
              });
            }

            if (key == this.selectedLandId) {
              this.onClickCell(cells[i][j]);
            }
          }
          ++idx;
        }
      }
    },
    // 전체 셀 목록 생성
    createCells() {
      const cells = [];
      for (let i = 0; i < this.rowCount; i++) {
        for (let j = 0; j < this.columnCount; j++) {
          if (!cells[i]) {
            cells[i] = {};
          } else {
            cells[i] = { x: j, y: i, i, j, key: 0, display: 0 };
          }
        }
      }
      this.cells = cells;
    },
    onClickCell(cell) {
      if (this.mapType == 0) {
        this.selectedLandId = 0;
        this.$store.commit("clickWorldMap", {
          key: cell.key
        });
      } else {
        this.selectedLandId = cell.key;
        this.$store.commit("clickMap", {
          key: cell.key,
          land: cell.land
        });
      }
    },
    isArea(cell, areas) {
      areas = areas || this.$store.state.area.areas;
      if (areas == null) {
        return false;
      }
      return areas.find(area => area.x === cell.x && area.y === cell.y);
    }
  }
};
</script>

<style scoped>
.grid-layer {
  position: absolute;
  width: 100%;
  height: 100%;
  user-select: none;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.5s;
}
table {
  position: absolute;
  left: 0;
  top: 0;
  border-collapse: collapse;
  table-layout: fixed;
}
.cell {
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.4);
  color: #fff;
  text-align: center;
  font-size: 1px;
}
.cell:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.cell-active {
  position: relative;
  color: #fff;
  text-align: center;
  font-size: 1px;
  box-shadow: 0 0 0 2px #ffc107 inset;
}

.cell-onsale {
  position: relative;
  color: #fff;
  text-align: center;
  font-size: 1px;
  box-shadow: 0 0 0 1px #ffffff inset;
}

.cell-notonsale {
  position: relative;
  color: #fff;
  text-align: center;
  font-size: 1px;
  box-shadow: 0 0 0 1px #333333 inset;
  background-color: #33333344;
}

table.transparent .cell {
  border-color: transparent;
}

td {
  padding: 0px;
}
</style>